import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import { grey1, grey10 } from 'approot/shared/styles/colours.style';

export const DrawPrintAnswers = styled.div`
  background-color: ${grey1};
  border: 1px solid ${grey10};
  border-radius: ${rem(borderRadius16)};
  margin: auto;
  position: relative;
  overflow: hidden;
  width: 100%;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
  }
`;

export const DrawPrintAnswersInner = styled.div`
  position: absolute;
  inset: 0;
`;
